import { createContext, useContext } from 'react'
import {
  ResolvedFeatureFlags,
  resolveFeatureFlags,
} from './types.ts'

export type FeatureFlagsContextValue = ResolvedFeatureFlags

/**
 * Default value resolves from localStorage only (no Keycloak groups). This
 * keeps {@link useFeatureFlag} working on unauthenticated/marketing pages
 * that render outside {@link FeatureFlagsProvider}.
 */
export const FeatureFlagsContext = createContext<FeatureFlagsContextValue>(
  resolveFeatureFlags(undefined),
)

/** Returns the fully resolved feature-flag state (flags, sources, groups). */
export function useFeatureFlags() {
  return useContext(FeatureFlagsContext)
}
